import React from 'react';

// Six large boxes for a 6-digit code. One real text input sits invisibly over the boxes, so typing, pasting,
// autofill (one-time-code) and screen readers behave exactly like the plain input it replaces. Display only.
export default function CodeBoxes({ id, value, onChange, length = 6, ...rest }) {
    const text = String(value || '');
    const active = Math.min(text.length, length - 1);
    return (
        <span className="code-boxes">
            <span className="code-boxes__cells" aria-hidden="true">
                {Array.from({ length }, (_, index) => (
                    <span key={index} className={`code-boxes__cell${index === active ? ' code-boxes__cell--active' : ''}`}>{text[index] || ''}</span>
                ))}
            </span>
            <input id={id} className="code-boxes__input" type="text" required pattern={`[0-9]{${length}}`} maxLength={length}
                inputMode="numeric" autoComplete="one-time-code" value={value} onChange={onChange} {...rest} />
        </span>
    );
}
